import { LayoutContext } from 'contexts/LayoutContext';
import React, { useContext } from 'react';
import { useModalView } from '@/design-system/components/modal/useModalView.hook';

import { AccountsTransfersStackRoutes, AccountsTransfersStackScreenProps } from './type';
import { AccountsTransfersWebZeroScreen } from './AccountsTransfersWebZero.screen';
import { AccountsTransfersNativeZeroScreen } from './AccountsTransfersNativeZero.screen';

export const AccountsTransfersMain: React.FC<AccountsTransfersStackScreenProps<AccountsTransfersStackRoutes.Main>> = ({
  navigation,
  route
}) => {
  const { onLayout, account, tab, onData, func, record, onReturnData, refresh } = route.params;
  const layout = useContext(LayoutContext);
  const onGoBack = () => {
    navigation.goBack();
  };
  const { useModalProps, closeModal } = useModalView({});
  if (layout.isMobile) {
    return (
      <AccountsTransfersNativeZeroScreen
        onClose={onGoBack}
        onLayout={onLayout}
        account={account}
        tab={tab}
        onData={onData}
        func={func}
        onReturnData={onReturnData}
        refresh={refresh}
        record={record}
      />
    );
  }

  return (
    <AccountsTransfersWebZeroScreen
      onClose={closeModal}
      onLayout={onLayout}
      account={account}
      tab={tab}
      onData={onData}
      func={func}
      onReturnData={onReturnData}
      refresh={refresh}
      record={record}
    />
  );
};
